import { GET_COLLABORATION_CATEGORIES_REQUEST,
    GET_COLLABORATION_CATEGORIES_SUCCESS,
    GET_COLLABORATION_CATEGORIES_FAILURE } from '../../../actions/collaborations/constants';

const INITIAL_STATE = {
    all: [],
    fetching: false,
    error: null
}

export default function categories(state = INITIAL_STATE, action) {
    switch(action.type) {
        case GET_COLLABORATION_CATEGORIES_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case GET_COLLABORATION_CATEGORIES_SUCCESS:
            return {
                ...state,
                all: action.payload,
                fetching: false
            }
        case GET_COLLABORATION_CATEGORIES_FAILURE:
            return {
                ...state,
                fetching: false,
                error: true,
                errorMsg: action.error
            }
        default:
            return state;
    }
}